import React from "react"
import { withTheme } from "emotion-theming"

const Twitter = ({ theme, colour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 14"
  >
    <path
      fill={colour || theme.colour}
      d="M15.1999.933399c-.6.333331-1.2667.600001-2 .800001-.6-.6-1.4-1.000002-2.2667-1.000002-1.73333 0-3.13333 1.400002-3.13333 3.200002 0 .26667 0 .46666.06667.73333-2.6-.13333-4.86667-1.4-6.4-3.33333-.26667.4-.4.93333-.4 1.53333 0 1.13334.53333 2.06667 1.4 2.66667-.53334 0-1-.13334-1.4-.4v.06667c0 1.53333 1.06666 2.86666 2.53333 3.13333-.26667.06666-.53333.13333-.8.13333-.2 0-.4 0-.6-.06667.4 1.26667 1.53333 2.20004 2.93333 2.20004-1.06666.8666-2.4 1.4-3.86666 1.4-.26667 0-.533337 0-.733337-.0667C1.9332 12.8667 3.5332 13.4001 5.3332 13.4001c5.7333 0 8.8667-4.8667 8.8667-9.0667v-.4c.6-.46667 1.1333-1 1.5333-1.66667-.5333.26667-1.1333.4-1.8.53333.5333-.53333 1-1.13333 1.2667-1.866661z"
    />
  </svg>
)

export default withTheme(Twitter)
